import { QRCodeSVG } from 'qrcode.react'
import { ExternalLink } from 'lucide-react'
import { ButtonLink, Card, CopyField } from '@/components/play'
import type { OnboardingCamera } from '@/lib/onboardingPayload'

interface Props {
  camera: OnboardingCamera
  /** Direct viewer URL — opens this camera straight on the map. */
  viewerUrl: string
  /** Public sponsor requirements page. */
  requirementsUrl: string
}

export function OnboardingCameraCard({ camera, viewerUrl, requirementsUrl }: Props) {
  return (
    <Card
      title={camera.name}
      headingLevel={3}
      description={
        camera.sponsor ? (
          <>
            with{' '}
            <a
              href={requirementsUrl}
              target="_blank"
              rel="noreferrer"
              className="text-neutral-10 underline underline-offset-4 hover:text-neutral-8"
            >
              {camera.sponsor.sponsor_name}
              <span className="sr-only"> (logo and creative requirements)</span>
            </a>
          </>
        ) : (
          'No sponsor'
        )
      }
    >
      {/* Public camera watch link */}
      <div className="flex flex-col items-center gap-3 rounded-xl bg-neutral-1 py-6">
        <div className="rounded-lg bg-neutral-1 p-2.5">
          <QRCodeSVG value={viewerUrl} size={150} level="M" />
        </div>
        <span className="text-size-xs font-medium text-neutral-7">
          Scan to watch
        </span>
      </div>

      {/* Public viewing link */}
      <div className="mt-4 space-y-3">
        <ButtonLink href={viewerUrl} target="_blank" rel="noreferrer" variant="secondary" className="w-full">
          Watch this camera
          <ExternalLink aria-hidden="true" />
        </ButtonLink>
        <CopyField label="Watch link" value={viewerUrl} />

        <p className="text-sm text-neutral-7">Ask your host for this camera’s invite to go live.</p>
      </div>
    </Card>
  )
}
